query InternalExpenseEdit($id: ID!) {
  internalExpense(id: $id) {
    id
    spentAt
    category
    title
    vendor
    amount {
      value
      currency
      valueUSD
    }
    note
  }
}
